// DAS-2770: the rebuy confrontation list. Shows stocks that were sold and later
// bought back materially higher — the clearest evidence that the original sale
// was emotion rather than judgement ("if you buy it back later, you never wanted
// to sell it; you wanted the fear to stop"). Renders nothing when the list is
// empty, so it can be mounted permanently.
import React, { useState, useEffect } from 'react';
import api from '../functions/api';

const price = (v) => (v == null ? '—' : v.toLocaleString('nl-NL', { maximumFractionDigits: 2 }));

const RebuyHistoryPanel = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/rebuy_history')
      .then(res => setData(res.data || null))
      .catch(() => setData(null));
  }, []);

  const completed = data?.completed || [];
  const watch = data?.watch || [];
  if (!completed.length && !watch.length) return null;

  const row = { display: 'flex', justifyContent: 'space-between', gap: 12, padding: '2px 0' };

  return (
    <div
      data-testid="rebuy-history-panel"
      style={{
        border: '1px solid #ffd591', borderRadius: 8, padding: '8px 14px',
        marginBottom: 12, fontSize: 13, maxWidth: 560, background: '#fffbe6',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>The rebuy tax</div>

      {completed.length > 0 && (
        <>
          <div style={{ color: '#666', marginBottom: 2 }}>
            Sold, then bought back higher — you never wanted to be out of these:
          </div>
          {completed.slice(0, 5).map((r) => (
            <div key={`c-${r.ticker}-${r.sold_date}`} style={row}>
              <span>
                <b>{r.ticker}</b> sold {r.sold_date} at {price(r.sold_price)} → bought {r.bought_date} at {price(r.bought_price)}
              </span>
              <b style={{ color: '#cf1322' }}>+{Math.round(r.pct_higher)}%</b>
            </div>
          ))}
        </>
      )}

      {watch.length > 0 && (
        <>
          <div style={{ color: '#666', marginTop: 6, marginBottom: 2 }}>
            Sold and not bought back — buying these back today would cost more:
          </div>
          {watch.slice(0, 5).map((r) => (
            <div key={`w-${r.ticker}-${r.sold_date}`} style={row}>
              <span>
                <b>{r.ticker}</b> sold {r.sold_date} at {price(r.sold_price)} → now {price(r.bought_price)}
              </span>
              <b style={{ color: '#d46b08' }}>+{Math.round(r.pct_higher)}%</b>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default RebuyHistoryPanel;
